import { breakpoints } from "@mui/system"
import headerphoto from "../../assets/headerphoto1.png"


export default function Projects() {
  return (
<div class="about">
      <h1>About</h1>

      <img src={headerphoto} width="80%" ></img>
      <break>
      
      </break>
    
  <p class="para">I am extremely excited about moving my career into full Stack Engineering and combining it with my existing degree in 
    Mechanical Engineering. I have included a sample of my projects. They cover most of my progress in the Full Stack Engineering BootCamp. </p>
 

 
  </div>
  )}